import { Fragment } from "react/jsx-runtime";
import { CalDataLine, CalJob, CalProject } from "./InnerCalendar";
import { CalendarContext, CalendarElementsProps } from "@/components/shared/VerticalCalendar";
import { useContext } from "react";
import dayjs from "dayjs";
import { useHolidayModal } from "../dialogs/HolidayModal";
import { Info } from "@mui/icons-material";

export default function HolidayCrewsLine({ offset, data }: { offset: number; data: CalDataLine<CalProject, CalJob> }) {
  const view = useContext(CalendarContext);
  const days = [];
  for (let dd = view?.calStart; dd <= view?.calEnd; dd = dd.add(1, "day")) {
    const date = dd.format("YYYY-MM-DD");
    const count = data.elements[date] ?? 0;
    const full = data.total;

    days.push(
      <div
        className={"vc-date holidaycrew color " + (count === 0 ? "green" : count === 1 ? "yellow" : count === 2 ? "orange" : "red")}
        key={"phase" + data.id + "_" + date}
        style={{
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          color: "rgba(0,0,0,0.8)",
          gridRow: offset,
          gridColumn: dd.diff(view.calStart, "days") + 2,
        }}
      >
        <div>
          {full - count}/{full}
        </div>
      </div>,
    );
  }

  return (
    <Fragment>
      <div
        key={"sidebar" + offset}
        className={"vc-sidebar project holidaydark"}
        style={{
          gridRow: offset,
        }}
      >
        {data.name}
      </div>

      {days}
      <div
        className="vc-hl"
        key={"hl" + offset}
        style={{
          gridRow: offset,
          gridColumn: 2 + " / " + (view.calEnd.diff(view.calStart, "days") + 2),
        }}
      ></div>
    </Fragment>
  );
}
